const SUPPORTED_IMAGE_TYPES = ['image/jpg', 'image/jpeg', 'image/heic', 'image/heif', 'image/x-icon', 'image/png', 'image/webp']

const SUPPORTED_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.heic', '.heif', '.ico', '.png', '.webp']

module.exports = {
    SUPPORTED_IMAGE_TYPES,
    SUPPORTED_IMAGE_EXTENSIONS
}